export default "__VITE_ASSET__BVOxabyB__"